import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchCount } from './drawAPI';

const initialState = {
  value: 0,
  status: 'idle',
  mice: [],
  mouse: undefined,
  users: undefined,
  dots: [],
  canPaint: true,
  paintColor: '#000000',
};

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched. Thunks are
// typically used to make async requests.
export const incrementAsync = createAsyncThunk(
  'draw/fetchCount',
  async (amount) => {
    const response = await fetchCount(amount);
    // The value we return becomes the `fulfilled` action payload
    return response.data;
  }
);

export const drawSlice = createSlice({
  name: 'draw',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    increment: (state) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.value += 1;
    },
    decrement: (state) => {
      state.value -= 1;
    },
    // Use the PayloadAction type to declare the contents of `action.payload`
    incrementByAmount: (state, action) => {
      state.value += action.payload;
    },
    handleInitResponse: (state, action) => {
      state.mice = action.payload.mice;
      state.mouse = action.payload.mouse;
      //state.dots = action.payload.dots;
      state.users = action.payload.users;
    },
    setCanPaint: (state, action) => {
      state.canPaint = action.payload;
    },
    setPaintColor: (state, action) => {
      state.paintColor = action.payload;
    },
    addMouseToMice: (state, action) => {
      let foundPlace = false;
      const newMice = state.mice.map(localMouse => {
        if(localMouse.id === action.payload.id) {
          foundPlace = true;
          return action.payload;
        } else {
          return localMouse;
        }
      });
      if(!foundPlace) {
        newMice.push(action.payload);
      }
      state.mice = newMice;
    },
    addUserToUsers: (state, action) => {
      let foundPlace = false;
      const newUsers = state.users.map(localUser => {
        if(localUser.id === action.payload.id) {
          foundPlace = true;
          return action.payload;
        } else {
          return localUser;
        }
      });
      if(!foundPlace) {
        newUsers.push(action.payload);
      }
      state.users = newUsers;
    }
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(incrementAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(incrementAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.value += action.payload;
      });
  },
});

export const { 
  increment, 
  decrement, 
  incrementByAmount,
  handleInitResponse,
  addMouseToMice,
  addUserToUsers,
  setCanPaint,
  setPaintColor,
} = drawSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectCount = (state) => state.draw.value;
export const selectMouse = (state) => state.draw.mouse;
export const selectMice = (state) => state.draw.mice;
export const selectDots = (state) => state.draw.dots;
export const selectUsers = (state) => state.draw.users;
export const selectCanPaint = (state) => state.draw.canPaint;
export const selectPaintColor = (state) => state.draw.paintColor;

// We can also write thunks by hand, which may contain both sync and async logic.
// Here's an example of conditionally dispatching actions based on current state.
export const incrementIfOdd = (amount) => (dispatch, getState) => {
  const currentValue = selectCount(getState());
  if (currentValue % 2 === 1) {
    dispatch(incrementByAmount(amount));
  }
};

export default drawSlice.reducer;
